import { ReactNode } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Card } from '@/components/ui/card';

interface MetricsCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: ReactNode;
  tooltipContent?: ReactNode;
}

export function MetricsCard({ title, value, subtitle, icon, tooltipContent }: MetricsCardProps) {
  const card = (
    <Card className="relative flex flex-col bg-card p-6 cursor-pointer">
      {/* Icon positioned in top right */}
      <div className="absolute right-6 top-6 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground">
        {icon}
      </div>

      {/* Main content */}
      <div className="flex flex-col gap-2">
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
        <p className="font-mono text-[32px] font-medium tracking-tight text-foreground">{value}</p>
        {subtitle && <p className="text-sm font-medium text-muted-foreground">{subtitle}</p>}
      </div>
    </Card>
  );

  if (!tooltipContent) {
    return card;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>{card}</PopoverTrigger>
      <PopoverContent className="w-[300px] p-0">{tooltipContent}</PopoverContent>
    </Popover>
  );
}
